import { Button, ChoiceChip } from "@lindar-joy/goosicorn-quickies-library";
import styled from 'styled-components';
import LeftOverlay from "./assets/BKG/DesktopBKG/LeftOverlay.png";
import RightOverlay from "./assets/BKG/DesktopBKG/RightOverlay.png";
import SquareBKG from "./assets/BKG/DesktopBKG/SquareBKG.png";
import TopTrees from "./assets/BKG/DesktopBKG/TopTrees.png";
import MobileBkg from "./assets/BKG/MobileBkg/MobileBKG.png";
import MobileLogo from "./assets/BKG/MobileBkg/MobileLogo.png";
import MobilePorcupines from "./assets/BKG/MobileBkg/MobilePorcupines.png";
import InGameLogo from "./assets/splash/Mines.png";

export const StyledMultiplierFrame = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;
    width: 50%;
`;
export const StyledCurrentWin = styled.span`
    font-family: Gilroy;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 160%;
`;
export const AddMines = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const Plus = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
export const NextMultiplierFrame = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    @media (orientation: portrait) {
        flex-direction: column;
        gap: 0px;
    }
`;
export const NextMultiplierText = styled.span`
    color: var(--white, #FFF);
    text-wrap: nowrap;
    font-family: Gilroy;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 160%;

    @media (max-width: 680px) {
        font-size: 9px;
        font-weight: 600;
        letter-spacing: 0.2px;
    }
`;
export const NextMultiplier = styled.span`
    display: flex;
    padding: 1px 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    background: var(--neutral-15, rgba(255, 255, 255, 0.15));

    @media (orientation: portrait) {
        font-size: 13px;
    }
`;

export const GridContainer = styled.div`
    width: 100%;
    position: relative;
`;

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    height: 100%;
    justify-content: center;

    @media (max-width: 680px) {
        padding: 10px;
        justify-content: space-between;
    }

    @media (max-height: 829px) {
        transform: scale(0.9);
    }

    @media (max-height: 620px) {
        transform: scale(0.7);
    }
`;
export const StyledMultiplierBar = styled.div`
    border-radius: 8px;
    background: var(--neutral-15, rgba(255, 255, 255, 0.15));
    display: flex;
    padding: 8px 24px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    height: 40px;
    width: 50%;
    box-sizing: border-box;
`;
export const BlockContainer = styled.div`
    display: grid;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 4px;
    column-gap: 4px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: start;
    align-content: flex-start;
`;
export const StyledButton = styled(Button)`
    align-self: stretch;
    width: 50%;
    height: 40px;
    @media (max-width: 680px) {
        font-size: 14px;
    }
`;
export const Background = styled.div`
    background-image: url(${SquareBKG});
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    background-size: cover;
`;
export const BackBushesBackground = styled.div`
    background-image: url(${TopTrees});
    position: absolute;
    z-index: -1;
    width: 35%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
`;
export const RightOverlayContainer = styled.div`
    background-image: url(${RightOverlay});
    position: absolute;
    z-index: -1;
    width: 35%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    right: 0;
    background-position: bottom;
`;
export const LeftOverlayContainer = styled.div`
    background-image: url(${LeftOverlay});
    position: absolute;
    z-index: -1;
    width: 35%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    left: 0;
    background-position: bottom;
`;
export const PhoneBackground = styled.div`
    background-image: url(${MobileBkg});
    width: 100%;
    height: 100%;
    background-size: cover;
    position: absolute;
    z-index: -1;
    
    @media (min-width: 680px) {
        display: none;
    }
`;

export const LogoContainer = styled.div`
    display: flex;
    border-radius: 12px;
    width: 100%;
    justifyContent: space-evenly;
    background-color: var(--neutral-15);
    height: 60px;
`;

export const Logo = styled.div`
    background-image: url(${InGameLogo});
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
`;

export const PhoneLogo = styled.div`
    background-image: url(${MobileLogo});
    width: 705px;
    height: 302px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    z-index: -1;
    position: absolute;
    transform: translateY(-282px) scale(0.5);
    transform-origin: bottom;
    @media (min-width: 590px) {
        display: none;
    }
`;

export const Porcupines = styled.div`
    background-image: url(${MobilePorcupines});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom;
    z-index: -1;
    position: absolute;
    bottom: -101px;
    width: 100%;
    aspect-ratio: 0.4;
    min-width: 535px;
    @media (min-width: 590px) {
        display: none;
    }
`;


export const MinesChoiceChip = styled(ChoiceChip)`
    width: 80px;
`;

